import { render, staticRenderFns } from "./ObjectImagesPreviewMobile.vue?vue&type=template&id=680c9f08&"
import script from "./ObjectImagesPreviewMobile.vue?vue&type=script&lang=js&"
export * from "./ObjectImagesPreviewMobile.vue?vue&type=script&lang=js&"
import style0 from "./ObjectImagesPreviewMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Touch})
